// extracted by mini-css-extract-plugin
module.exports = {"action-wrapp":"action-wrapp","actionWrapp":"action-wrapp","action-wrapp_center":"action-wrapp_center","actionWrappCenter":"action-wrapp_center"};